import React, { createContext, useContext, useState, useCallback } from 'react';

const StoryContext = createContext(null);

export const STEPS = {
  LANDING: 0,
  PROTAGONIST_TYPE: 1, // Noi o Noia
  NAME: 2,
  COVER: 3, // Portada personalizada
  PREVIEW: 4,
  FORM: 5,
  SUCCESS: 6
};

export function StoryProvider({ children }) {
  const [currentStep, setCurrentStep] = useState(STEPS.LANDING);
  const [protagonistType, setProtagonistType] = useState(null); // 'noi' or 'noia'
  const [protagonistName, setProtagonistName] = useState('');
  const [storyData, setStoryData] = useState(null);
  const [uiTexts, setUiTexts] = useState(null);
  const [leadId, setLeadId] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Always Catalan
  const language = 'ca';

  const goToStep = useCallback((step) => {
    setCurrentStep(step);
    setError(null);
  }, []);

  const goBack = useCallback(() => {
    if (currentStep > STEPS.LANDING) {
      setCurrentStep(currentStep - 1);
      setError(null);
    }
  }, [currentStep]);

  const reset = useCallback(() => {
    setCurrentStep(STEPS.LANDING);
    setProtagonistType(null);
    setProtagonistName('');
    setStoryData(null);
    setUiTexts(null);
    setLeadId(null);
    setPdfUrl(null);
    setUserEmail('');
    setIsLoading(false);
    setError(null);
  }, []);

  const value = {
    currentStep,
    setCurrentStep,
    goToStep,
    goBack,
    language,
    protagonistType,
    setProtagonistType,
    protagonistName,
    setProtagonistName,
    storyData,
    setStoryData,
    uiTexts,
    setUiTexts,
    leadId,
    setLeadId,
    pdfUrl,
    setPdfUrl,
    userEmail,
    setUserEmail,
    isLoading,
    setIsLoading,
    error,
    setError,
    reset
  };

  return (
    <StoryContext.Provider value={value}>
      {children}
    </StoryContext.Provider>
  );
}

export function useStory() {
  const context = useContext(StoryContext);
  if (!context) {
    throw new Error('useStory must be used within a StoryProvider');
  }
  return context;
}
